<template lang="pug">
#online-bill-pay.online-bill-pay
	div(v-if="!loading")
		invoice-lookup(v-if="mode === 'invoice'", @proceedToPayment="proceedToPayment()")
		payment-form(v-if="mode === 'payment'", @goBack="goBack()", @reset="resetApp()")
</template>

<script>
import  { mapGetters, mapActions } from "vuex";
import InvoiceLookup from "./components/invoice-lookup"
import PaymentForm from "./components/payment-form"

export default {
  name: "OnlineBillPaay",
	components: {
		InvoiceLookup,
		PaymentForm
	},
  data: function () {
    return {
    	mode: 'invoice'
    };
  },
  computed: {
		...mapGetters(["config", "loading"]),
	},
  methods: {
		...mapActions(["loadConfig", "resetData"]),
	  resetApp() {
			this.goBack();
			this.resetData();
	  },
	  proceedToPayment() {
			this.mode = 'payment';
		  document.querySelectorAll('.HideOnStep2').forEach((el) => {
			  el.style.display = 'none';
		  });
	  },
	  goBack() {
		  this.mode = 'invoice';
		  document.querySelectorAll('.HideOnStep2').forEach((el) => {
			  el.style.display = 'block';
		  });
	  }
	},
	created() {
		this.loadConfig(this.$root.config);
		console.log(new Date().toISOString());
	}
};
</script>

<style scoped lang="scss">
.online-bill-pay {
	&__table {
		border: 1px solid $lightGray;
		border-collapse: collapse;
		margin: 0;
		padding: 0;
		width: 100%;
		table-layout: fixed;
		thead {
			tr {
				background-color: $orange;
				color: $white;
			}
		}
		tr {
			background-color: $neutralGray;
			border: 1px solid $lightGray;
			padding: .35em;
		}
		th,
		td {
			position: relative;
			padding: .625em;
			text-align: right;
			&.override-align {
				text-align: left;
			}
		}
		th {
			font-size: .85em;
			letter-spacing: .1em;
			text-transform: uppercase;
		}
	}
	&__input {
		height: 37px;
		width: 100%;
	}
	&__search,
	&__remove {
		cursor: pointer;
		border: 0;
	}
	&__search {
		padding: .5rem 1rem;
		position: absolute;
		right: 1rem;
		top: .625em;
		&::after {
			@include icon;
			margin-left: .5rem;
			content: "\e902";
			font-weight: bold;
		}
	}
	&__remove {
		background: none;
		color: red;
		&::before {
			@include icon;
			content: "\e90e";
			font-weight: bold;
		}
	}
	&__footer {
		padding-top: 2rem;
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		h5 {
			margin: auto 0;
		}
	}

	@media screen and (max-width: 900px) {
		&__table {
			border: 0;
			thead {
				border: none;
				clip: rect(0 0 0 0);
				height: 1px;
				margin: -1px;
				overflow: hidden;
				padding: 0;
				position: absolute;
				width: 1px;
			}
			tr {
				border-bottom: 3px solid $lightGray;
				display: block;
				margin-bottom: .625em;
			}

			td {
				display: none;
				&:before {
					content: attr(data-label);
					float: left;
					font-weight: bold;
					text-transform: uppercase;
				}
				&:last-child {
					border-bottom: 0;
				}
				&[data-label] {
					border-bottom: 1px solid $lightGray;
					display: block;
					font-size: .8em;
					text-align: right;
				}
			}
		}
		&__input {
			width: unset;
			height: unset;
		}
		&__search {
			position: unset;
			width: 100%;
		}
	}

}
</style>
